"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = exports.UNLIMITED_ALLOWANCE = exports.ETHER_ADDRESS = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const ETHER_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
exports.ETHER_ADDRESS = ETHER_ADDRESS;
const UNLIMITED_ALLOWANCE = new bignumber_js_1.default(2).pow(256).minus(1).toFixed();
exports.UNLIMITED_ALLOWANCE = UNLIMITED_ALLOWANCE;
class User {
    constructor(address, network = 1, tokens) {
        this.address = address;
        this.network = network;
        this.tokens = tokens;
    }
}
exports.User = User;
//# sourceMappingURL=types.js.map